"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _pickToolTipName = _interopRequireDefault(require("./UIAvatarDisplay/pickToolTipName"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIAvatarRequest = _interopRequireDefault(require("./UIAvatarRequest"));

var _Constants = require("./Constants");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: flex-end;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var AvatarListWrapper = (0, _styledComponents.default)('div').withConfig({
  displayName: "UIAvatarMultiOrSingle__AvatarListWrapper",
  componentId: "sc-1ntpk29-0"
})(_templateObject());

var UIAvatarMultiOrSingle = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UIAvatarMultiOrSingle, _Component);

  function UIAvatarMultiOrSingle() {
    (0, _classCallCheck2.default)(this, UIAvatarMultiOrSingle);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIAvatarMultiOrSingle).apply(this, arguments));
  }

  (0, _createClass2.default)(UIAvatarMultiOrSingle, [{
    key: "makeNumberAvatar",
    value: function makeNumberAvatar() {
      var _this$props = this.props,
          _truncateAvatarListInTooltip = _this$props._truncateAvatarListInTooltip,
          hasMoreHref = _this$props.hasMoreHref,
          lookup = _this$props.lookup,
          maxAvatars = _this$props.maxAvatars;
      var offsetMax = maxAvatars - 1;
      var remainingAvatarsNumber = lookup.length - offsetMax;
      var remainingAvatarsNumberLimit = remainingAvatarsNumber > 9 ? 9 : remainingAvatarsNumber;
      var remainingAvatars = lookup.slice(offsetMax, offsetMax + 9);
      var hasMoreAvatarDisplay = remainingAvatarsNumber ? '+' : '';
      var displayList = this.avatarsToDisplayList(remainingAvatars);

      if (_truncateAvatarListInTooltip && remainingAvatars.length < remainingAvatarsNumber) {
        displayList = _I18n.default.text('uiAddonAvatars.tooltip.hasMore', {
          list: displayList
        });
      }

      return {
        displayName: remainingAvatarsNumberLimit + " " + hasMoreAvatarDisplay,
        _isHasMore: true,
        href: hasMoreHref,
        _toolTipOverWrite: displayList
      };
    }
  }, {
    key: "avatarsToDisplayList",
    value: function avatarsToDisplayList(arrayOfObjects) {
      return arrayOfObjects.map(_pickToolTipName.default).join(', ');
    }
  }, {
    key: "renderAvatarList",
    value: function renderAvatarList() {
      var _this = this;

      var _this$props2 = this.props,
          _hasMoreOverWrite = _this$props2._hasMoreOverWrite,
          childClassName = _this$props2.childClassName,
          childStyles = _this$props2.childStyles,
          className = _this$props2.className,
          lookup = _this$props2.lookup,
          maxAvatars = _this$props2.maxAvatars,
          portalId = _this$props2.portalId,
          fetchAvatars = _this$props2.fetchAvatars,
          size = _this$props2.size;
      var isHiddenAvatars = !!_hasMoreOverWrite || lookup.length > maxAvatars;
      var newLookupList = isHiddenAvatars ? lookup.slice(0, maxAvatars - 1) : lookup.slice(0);

      if (isHiddenAvatars) {
        newLookupList.push(this.makeNumberAvatar());
      }

      return _react.default.createElement(AvatarListWrapper, {
        className: className
      }, newLookupList.reverse().map(function (lookupObj, i) {
        var avatarLookupWithReverse = Object.assign({
          className: childClassName,
          _isListReversed: true,
          portalId: portalId,
          fetchAvatars: fetchAvatars,
          size: size,
          style: childStyles
        }, lookupObj);
        return _this.renderSingleAvatar(avatarLookupWithReverse, i);
      }));
    }
  }, {
    key: "renderSingleAvatar",
    value: function renderSingleAvatar(props, key) {
      var companyId = props.companyId,
          displayName = props.displayName,
          domain = props.domain,
          email = props.email,
          existsInPortal = props.existsInPortal,
          fetchAvatars = props.fetchAvatars,
          fileManagerKey = props.fileManagerKey,
          hubSpotUserEmail = props.hubSpotUserEmail,
          lookup = props.lookup,
          primaryIdentifier = props.primaryIdentifier,
          secondaryIdentifier = props.secondaryIdentifier,
          socialNetwork = props.socialNetwork,
          src = props.src,
          type = props.type,
          vid = props.vid,
          rest = (0, _objectWithoutProperties2.default)(props, ["companyId", "displayName", "domain", "email", "existsInPortal", "fetchAvatars", "fileManagerKey", "hubSpotUserEmail", "lookup", "primaryIdentifier", "secondaryIdentifier", "socialNetwork", "src", "type", "vid"]);
      var proxyLookup = lookup || {};
      return _react.default.createElement(_UIAvatarRequest.default, (0, _extends2.default)({
        companyId: companyId || proxyLookup.companyId,
        displayName: displayName || proxyLookup.displayName || email || proxyLookup.email || domain || proxyLookup.domain || secondaryIdentifier || proxyLookup.secondaryIdentifier || primaryIdentifier || proxyLookup.primaryIdentifier,
        domain: domain || proxyLookup.domain,
        email: email || proxyLookup.email,
        existsInPortal: existsInPortal || proxyLookup.existsInPortal,
        fetchAvatars: fetchAvatars,
        fileManagerKey: fileManagerKey || proxyLookup.fileManagerKey,
        hubSpotUserEmail: hubSpotUserEmail || proxyLookup.hubSpotUserEmail,
        key: key,
        primaryIdentifier: primaryIdentifier || proxyLookup.primaryIdentifier,
        socialNetwork: proxyLookup.socialNetwork || socialNetwork,
        secondaryIdentifier: secondaryIdentifier || proxyLookup.secondaryIdentifier,
        src: src || proxyLookup.src,
        type: type || proxyLookup.type,
        vid: vid || proxyLookup.vid
      }, rest));
    }
  }, {
    key: "render",
    value: function render() {
      var lookup = this.props.lookup;

      if (lookup && Array.isArray(lookup)) {
        return this.renderAvatarList();
      }

      return this.renderSingleAvatar(this.props);
    }
  }]);
  return UIAvatarMultiOrSingle;
}(_react.Component);

var PropTypeChildClassName = function PropTypeChildClassName(props, propName, componentName) {
  for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    rest[_key - 3] = arguments[_key];
  }

  _propTypes.default.string.apply(_propTypes.default, [props, propName, componentName].concat(rest));

  if (props[propName] && !Array.isArray(props.lookup)) {
    return new Error(componentName + ": " + propName + " is only applied when lookup is an array.");
  }

  return null;
};

var PropTypeChildStyles = function PropTypeChildStyles(props, propName, componentName) {
  for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
    rest[_key2 - 3] = arguments[_key2];
  }

  _propTypes.default.string.apply(_propTypes.default, [props, propName, componentName].concat(rest));

  if (props[propName] && !Array.isArray(props.lookup) && props.lookup.length > 1) {
    return new Error(componentName + ": " + propName + " is only applied when lookup is an array that can make children.");
  }

  return null;
};

var PropTypeMaxAvatars = function PropTypeMaxAvatars(props, propName, componentName) {
  if (props[propName] < 2) {
    return new Error(propName + " needs to be at least 2 in " + componentName + ".");
  }

  return null;
};

var PropTypeHasMoreHref = function PropTypeHasMoreHref(props, propName, componentName) {
  if (props[propName] && !props.maxAvatars) {
    return new Error(propName + " will only work if maxAvatars is set in " + componentName);
  }

  return null;
};

UIAvatarMultiOrSingle.propTypes = (0, _extends2.default)({}, _UIAvatarRequest.default.propTypes, {
  _truncateAvatarListInTooltip: _propTypes.default.bool,
  childClassName: PropTypeChildClassName,
  childStyles: PropTypeChildStyles,
  className: _propTypes.default.string,
  fetchAvatars: _propTypes.default.func,
  hasMoreHref: PropTypeHasMoreHref,
  lookup: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array]),
  maxAvatars: PropTypeMaxAvatars,
  portalId: _propTypes.default.number,
  size: _propTypes.default.oneOf(Object.keys(_Constants.AVATAR_SIZES))
});
var _default = UIAvatarMultiOrSingle;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.2401/js/UIAvatarMultiOrSingle.js
// module id = 854
// module chunks = 209 210 211 212